import {
  INITIAL_STATE_ITINERARIES,
  REQUEST_FETCH_ITINERARIES,
  FETCH_ITINERARIES_SUCCESS,
  FETCH_ITINERARIES_ERROR,
} from "../../../actions/b2b/yachts/fetchItineraries";

const initialState = {
  itineraries: [],
  itinerary: {},
  processing: false,
  fetching: false,
  message: "",
  error: "",
};

const yachtsReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIAL_STATE_ITINERARIES: {
      return {
        ...state,
        itineraries: [],
        itinerary: {},
        processing: false,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case REQUEST_FETCH_ITINERARIES: {
      return {
        ...state,
        itineraries: [],
        itinerary: {},
        processing: false,
        fetching: true,
        message: "",
        error: "",
      };
    }
    case FETCH_ITINERARIES_SUCCESS: {
      return {
        ...state,
        itineraries: action.itineraries,
        itinerary: {},
        processing: false,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case FETCH_ITINERARIES_ERROR: {
      return {
        ...state,
        itineraries: [],
        itinerary: {},
        processing: false,
        fetching: false,
        message: "",
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

export default yachtsReducer;
